<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto">
        <ul class="flex border-b">
          <li class="-mb-px mr-1" v-on:click="selectTab = 'personal_information'">
            <a
              class="bg-white inline-block font-semibold"
              v-bind:class="[selectTab=='personal_information' ? 'border-l border-t border-r rounded-t py-2 px-4 text-blue-700' : 'py-2 px-4 text-blue-500 hover:text-blue-800']"
            >Información Personal</a>
          </li>
          <li class="-mb-px mr-1" v-on:click="selectTab = 'update_password'">
            <a
              class="bg-white inline-block font-semibold"
              v-bind:class="[selectTab=='update_password' ? 'border-l border-t border-r rounded-t py-2 px-4 text-blue-700' : 'py-2 px-4 text-blue-500 hover:text-blue-800']"
            >Actualizar Contraseña</a>
          </li>
        </ul>
        <div>
          <div v-if="selectTab=='personal_information'" id="personal_information">
            <div class="w-full px-4 py-2">
              <div class="w-full flex items-center">
                <div class="w-4/12">
                  <div class="relative w-40 h-40">
                    <img
                      :src="profile.image"
                      class="h-full w-full object-cover mt-1 rounded-full"
                      alt
                      @error="defaultProfile"
                    >
                  </div>
                </div>
                <div class="flex flex-col w-8/12 pl-4 ml-6">
                  <div class="w-full flex flex-wrap items-center">
                    <div class="w-full">
                      <div class="flex items-center pt-2 text-sm">
                        <span class="font-bold text-gray-900">Nombre:</span>
                        <span class="ml-2 text-gray-700">{{monitor.name}}</span>
                      </div>
                      <div class="flex items-center pt-2 text-sm">
                        <span class="font-bold text-gray-900">Apellidos:</span>
                        <span class="ml-2 text-gray-700">{{monitor.last_name}}</span>
                      </div>
                      <div class="flex items-center pt-2 text-sm">
                        <span class="font-bold text-gray-900">Correo:</span>
                        <span class="ml-2 text-gray-700">{{monitor.email}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="selectTab=='update_password'" id="update_password">
            <form class="w-full" id="updatePasswordForm" @submit.prevent>
              <div class="flex flex-wrap -mx-3 mt-4">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="new_password"
                  >Nueva Contraseña *</label>
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="new_password"
                    type="password"
                    name="new_password"
                    v-model="profile.new_password"
                  >
                  <p
                    v-if="errors.new_password"
                    class="text-red-500 text-xs italic"
                  >Ingrese una contraseña.</p>
                  <p
                    v-if="errors.valid_password"
                    class="text-red-500 text-xs italic"
                  >La contraseña no coincide.</p>
                </div>
              </div>

              <div class="flex flex-wrap -mx-3">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="password_again"
                  >Repetir Contraseña *</label>
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="password_again"
                    type="password"
                    name="password_again"
                    v-model="profile.password_again"
                  >
                  <p
                    v-if="errors.password_again"
                    class="text-red-500 text-xs italic"
                  >Ingrese una contraseña.</p>
                </div>
              </div>
              <div class="flex flex-wrap -mx-3">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="old_password"
                  >Ingrese su Contraseña Actual *</label>
                  <input
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="old_password"
                    type="password"
                    name="old_password"
                    v-model="profile.old_password"
                  >
                  <p
                    v-if="errors.old_password"
                    class="text-red-500 text-xs italic"
                  >Ingrese una contraseña.</p>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="flex w-full justify-end mt-3">
          <button
            v-if="selectTab=='update_password'"
            class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
            @click="updatePassword()"
          >Actualizar</button>
          <button
            v-if="selectTab=='personal_information'"
            v-on:click="updateDataModal(monitor)"
            class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
          >Editar</button>
          <button
            class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
            @click="close()"
          >Cerrar</button>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Contraseña Cambiada Correctamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{errors.codeError}}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            ></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false; errors.codeError = 'Ha ocurrido un error'"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <monitor-modal
      :newMonitor="newMonitor"
      :showing="showMonitorModal"
      :viewModal="viewModal"
      @updateMonitor="updateMonitor"
      @close="showMonitorModal = false"
    ></monitor-modal>
  </div>
</template>

<script>
import config from "../../vue.config.js";
import { backend_url } from "../config/url.config.ts";
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";
import MonitorModal from "./MonitorModal";
import axios from "axios";

export default {
  name: "profile-modal",
  data() {
    return {
      viewModal: "profile_modal",
      showMonitorModal: false,
      newMonitor: false,
      monitor: null,
      selectTab: "personal_information",
      profile: {
        email: localStorage.getItem("email"),
        image: localStorage.getItem("profile_image"),
        new_password: null,
        password_again: null,
        old_password: null
      },
      errors: {
        old_password: false,
        password_again: false,
        valid_password: false,
        new_password: false,
        repeat_password: false,
        codeError: "Ha ocurrido un error"
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    }
  },
  components: {
    AlertDialog,
    MonitorModal
  },
  mounted() {
    this.getMonitor();
  },
  methods: {
    reset: function() {
      this.profile.new_password = null;
      this.profile.password_again = null;
      this.profile.old_password = null;
      this.errors = {
        old_password: false,
        password_again: false,
        valid_password: false,
        new_password: false,
        repeat_password: false,
        codeError: "Ha ocurrido un error"
      };
    },
    close() {
      this.reset();
      this.$emit("close");
    },
    getMonitor: function() {
      axios
        .post(
          backend_url + "/users/info",
          {
            type: "monitor",
            email: this.profile.email
          },
          this.config
        )
        .then(response => {
          this.monitor = response.data;
          this.monitor.profile_image = this.getImage(this.monitor.profile_image)
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.showingError = true;
        });
    },
    getImage: function(img) {
      if (img != null) {
        this.profile.image = backend_url + "/" + img;
      } else {
        this.profile.image =
          "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
      }
      return this.profile.image
    },
    defaultProfile: function() {
      this.profile.image =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    },
    updatePassword() {
      const form = document.getElementById("updatePasswordForm");
      const formData = new FormData(form);
      const validForm = this.checkFormUpdatePassword(formData);
      if (validForm) {
        axios
          .post(
            backend_url + "/users/update_my_password",
            {
              new_password: this.profile.new_password,
              old_password: this.profile.old_password
            },
            this.config
          )
          .then(response => {
            this.showingSuccess = true;
            this.reset();
            this.$emit("close");
          })
          .catch(error => {
            console.error(error.response);
            if (error.response.status == 400 || error.response.status == 401) {
              if (
                error.response.data.name === "TokenExpiredError" ||
                error.response.data.name === "InvalidTokenError" ||
                error.response.data.name === "JsonWebTokenError"
              ) {
                this.$router.push({ path: "/login" });
              }
            }
            this.showingError = true;
          });
      }
    },
    updateDataModal: function(monitor) {
      this.showMonitorModal = true;
      this.newMonitor = false;
      EventBus.$emit("editModal", monitor);
    },

    updateMonitor: function(monitor) {
      //console.log("UPDATE",monitor)
      localStorage.setItem("profile_image",monitor.profile_image)
      this.getMonitor();
    },
    checkFormUpdatePassword: function(data) {
      if (data.get("new_password") === "") {
        this.errors.new_password = true;
      } else {
        this.errors.new_password = false;
      }

      if (data.get("password_again") === "") {
        this.errors.password_again = true;
      } else {
        this.errors.password_again = false;
      }

      if (data.get("old_password") === "") {
        this.errors.old_password = true;
      } else {
        this.errors.old_password = false;
      }

      if (data.get("new_password") !== data.get("password_again")) {
        this.errors.valid_password = true;
        return false;
      } else {
        this.errors.valid_password = false;
      }

      if (data.get("new_password") === data.get("old_password")) {
        this.showingError = true;
        this.errors.codeError = "Introduzca una contraseña diferente";
      } else {
        this.showingError = false;
      }

      if (
        this.errors.new_password ||
        this.errors.password_again ||
        this.errors.valid_password ||
        this.errors.old_password ||
        this.showingError
      ) {
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>